export default {
  searchText: '',
  orderName: 'created_at',
  sortAsc: false,
  step: null,
  rentStatus: 1,
  groupId: null,
  machineId: null,
  machineType: null,
  createdAt: null,
  createdBy: null,
  createdType: null,
  rentStartDate: null,
  rentEndDate: null,
  useStartDate: null,
  useEndDate: null,
  limit: null,
  page: 1,
  // 圃場選択モーダル用
  fieldSearchText: '',
  fieldCurrentPage: 1,
  fieldOrderName: 'field_name',
  fieldSortAsc: true,
  // 除草警報から貸出追加に遷移した際の初期値用
  initialFieldId: null,
  accountId: null
}
